const zh = {
  news: {
    sort: '排序',
    publishTime: '发布时间',
    sales: '销量',
    values: '推荐值',
    create: '创建串货关系',
    msg1: '自动创建对应的分销商和供应商',
    msg2: '直接使用全球货仓支付，一单一清',
    msg3: '分别手工指定分销商和供应商',
    msg4: '跟对方协商支付方式'
  },
  common: {
    all: '全部',
    ticket: '门票',
    package: '套餐',
    route: '路线',
    hotel: '住宿',
    buy: '抢购',
    performance: '演出',
    carRental: '租车',
    visa: '签证',
    airTickets: '机票',
    commodities: '商品',
    flashSale: '抢购',
    carRentalNew: '租车(新)',
    traffic: '交通',
    pleaseInput: '请输入{name}',
    search: '搜索',
    allLanguage: '全部语言',
    chinese: '简体中文',
    japanese: '日文',
    english: 'English',
    setting: '设置',
    classification: '分类',
    changeLanguage: '切换语言',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    finalPrice: '结算价',
    retailPrice: '零售价',
    bind: '绑定关系',
    oneBind: '一键绑定',
    handBind: '手工绑定',
    unbind: '取消引用',
    quote: '引用产品',
		// 弹窗
    close: '关闭',
    quoteProduct: '引用产品',
    quoteCentence: '确定引用产品？',
    confirm: '确定',
    cancel: '取消',
    unbindProduct: '取消引用',
    unbindCentence: '确定取消引用产品？',
    noData: '暂无数据',
    validity: '有效期',
    review: '审核中',
    noMore: '没有更多数据了',
    queryFailed: '查询失败',
    startDate: '开始日期',
    endDate: '结束日期'
  },
  home: {
    myCenter: '商户中心',
    continent: '大洲/国家',
    country: '国家/省份',
    province: '省份/城市',
    cities: '城市/地区',
    destination: '目的地',
    quickSearch: '快速搜索',
    periphery: '周边',
    inland: '国内',
    overseas: '境外',
    HMT: '港澳台',
    hotRecommend: '热门推荐',
    hotRanking: '最热产品排行',
    newRanking: '最新产品排行',
    centent: '全球旅游产品任你搜',
    list: '住宿、门票、套餐、线路...',
    openWarehouse: '确认开启全球货仓',
    yes: '是',
    no: '否',
    agree: '我已阅读并同意',
    terms: '使用条款',
    operatorNav: '商户导航',
    keyContent: '产品名称 / 景区名称 / 产品编号关键字'
  },
  account: {
    home: '去货仓首页',
    accountSetting: '账户设置',
    myPage: '我的主页',
    myProducts: '我的产品',
    relatedBusinessess: '关联商家',
    systemGrade: '个人总评分',
    systemRecommended: '系统推荐',
    serviceLevel: '服务质量',
    serviceSpeed: '处理速度',
    realInventory: '实时库存',
    hotSelling: 'TA的热销产品',
    CNY: '人民币CNY',
    JPY: '日元JPY',
    KRW: '韩币KRW',
    USD: '美元USD',
    accountBalance: '账户余额',
    salesAchievement: '销售成就',
    number: '数量',
    orderTotal: '订单总额',
    selling: '卖出(共',
    buying: '买入(共',
    bracket: ')个',
    merchantName: '商家名称',
    correlationTime: '关联时间',
    sellingNumber: '卖出数量',
    buyingNumber: '买入数量',
    unbind: '解除关系',
    recharge: '充值',
    withdrawal: '提现',
    transactionDetail: '交易明细',
    unbindTip: '此操作将导致产品引用数据清空，是否确认解除关系？',
    tip: '提示',
    unbindSuccess: '关系解除成功!',
    unbindFail: '关系解除失败!',
    successModify: '修改成功',
    failedModify: '修改失败',
    viewDis: '查看串货订单',
    viewSup: '查看被串货订单'
  },
  cash: {
    unit: '元',
    Withdrawal: '提现金额',
    withdrawal: '提现(',
    bracket: '币种)',
    myCenter: '商户中心',
    withdrawalRecord: '提现记录',
    accountBalance: '账户余额',
    withdrawalAmount: '可提现金额',
    line: '(未游玩订单只能提现0%)',
    choose: '选择提现方式',
    amount: '提现金额',
    enter: '输入金额',
    contrl: '提现',
    explanation: '提现说明',
    line1: '当前系统支持提现到支付宝或银行账户；',
    line2: '系统一旦绑定账户不能自主更换，如需修改绑定账户请联系运营商申请；',
    line3: '提现手续费用：千分之 三 /笔(小于0.01元按0.01计算)',
    line6: '用户提交提现申请后，运营商会在一个工作日之内处理；',
    line7: '申请提现后，系统会调用当前的支付宝账户或者银行账户生成提现记录，提现记录生成后，不可做任何操作；',
    line8: '用户使用全球货仓供应商功能需在账户余额中留存与3000元人民币等值的金额作为信用保证金，用户可提现部分为超过3000元人民币部分（或超过等价于3000元人民币外币）；',
    line9: '用户只有在所有作为供应商的订单为已完成状态的30日之后，方可全部提取信用保证金；',
    amountTip: '请输入提现金额',
    validAmount: '请输入可提现金额范围内数字！',
    selectAccount: '请选择账户',
    servicePay: '千分之三/每笔',
    notAllow: '不可提现',
    reserveTip: '成为全球货仓供应商需在账户余额中留存与3000元人民币等值的金额作为信用保证金，且只有在所有作为供应商的订单为已完成状态的30日之后方可提取',
    userName: '用户真实姓名',
    accountNum: '账号',
    tail: '尾号'
  },
  operator: {
    telephone: '电话',
    address: '地址',
    systemGrade: 'TA的总评分',
    systemRecommended: '系统推荐',
    serviceLevel: '服务质量',
    serviceSpeed: '处理速度',
    realInventory: '实时库存',
    hotSelling: 'TA的热销产品',
    webSite: '网址'
  },
  recharge: {
    unit: '元',
    Recharge: '充值',
    recharge: '充值(',
    bracket: '币种)',
    myCenter: '商户中心',
    rechargeRecord: '充值记录',
    RtoB: '充值到余额',
    enter: '填写金额',
    payee: '收款单位',
    depositCard: '网银',
    escrow: '第三方支付',
    underLine: '线下充值',
    saasBalance: '余额充值',
    cardWarn: '*银行网关支付,不支持信用卡',
    escrowWarn: '*其中易宝支付通道支持信用卡',
    amountTip: '请输入充值金额',
    accountTip: '请选择支付账户',
    rechargeDes: '充值说明',
    line3: '充值手续费用：',
    line4: '商家通过支付宝或网银充值的手续费均为交易额的千分之 一 (小于0.01元按0.01计算)',
    amountNum: '充值金额至少￥10元',
    underLinStep1Label: '第一步',
    underLinStep1Val: '首先通过转账等方式将充值的金额存入到自我游账户下',
    underLinStep2Label: '第二步',
    underLinStep2Val: '保存好银行资金处理信息（流水号、金额、银行等）',
    underLinStep3Label: '第三步',
    underLinStep3Val: '找到自我游客服QQ，讲信息发给客服处理',
    underLinStep4Label: '第四步',
    underLinStep4Val: '等待自我游审核资料',
    underLinStep5Label: '第五步',
    underLinStep5Val: '全球货仓账户充值完毕'
  },
  search: {
    pleaseEnter: '请输入{name}',
    myCenter: '商户中心',
    home: '去货仓首页',
    continent: '大洲/国家',
    country: '国家/省份',
    province: '省份/城市',
    cities: '城市/地区',
    keywords: '关键字',
    keyContent: '产品名称 / 景区名称 / 产品编号关键字'
  },
  popup: {
    about: {
      aboutUs: '关于我们',
      companyProfile: '公司简介',
      profile1: '全球旅游货仓（gtpw.zowoyoo.com）是国内领先的旅游B2B技术型平台。全球旅游货仓致力成为全球旅游碎片化产品的交易枢纽，通过自有技术平台有效匹配旅游业的供需，一键完成供应商筛选，最优产品配对及支付问题，旨在帮助用户轻松获取全球碎片化旅游产品资源。'
    },

    contact: {
      contactUs: '联系我们',
      name: '广州智我优旅行社有限公司总部（全球旅游货仓）',
      address: '地址:广州市天河区黄埔大道中309号羊城创意产业园3-08栋1楼A区',
      email: '企业邮箱',
      website: '网站',
      account: '体验账号',
      password: '体验密码',
      supply: '供应合作',
      distribution: '分销合作',
      market: '市场合作',
      telephone: '客服电话',
      qq: '客服QQ'

    },
    account: {
      account: '账号设置',
      introduction: '商家介绍',
      contact: '联系方式',
      telephone: '电话',
      qq: 'QQ',
      address: '地址',
      save: '保存修改'
    },
    transaction: {
      detail: '交易明细',
      dealDate: '交易日期',
      today: '今天',
      yesterday: '昨天',
      '7days': '最近7天',
      '30days': '最近30天',
      chooseDate: '选择日期',
      paymentsType: '收支类型',
      all: '全部',
      income: '收入',
      expense: '支出',
      tradingContent: '交易内容',
      tradingMerchant: '交易商家',
      recharge: '充值',
      withdrawal: '提现',
      pay: '支付',
      refund: '退款',
      number: '订单号/通知单号',
      date: '日期',
      operator: '操作人',
      expenseAmount: '支出金额',
      incomeAmount: '收入金额',
      currencyBalance: '币种余额',
      remark: '备注',
      endTip: '请输入结束时间',
      startTip: '请输入开始时间',
      orderValid: '请输入合法的单号',
      orderId: '订单号',
      export: '导出',
      exportTip: '一次最多导出20000条记录，您可以缩小要查询的时间范围进行多次导出',
      noData: '无相关数据'
    },
    relation: {
      title: '建立串货关系',
      systemSupplier: '本系统供应商',
      province: '大洲/国家',
      city: '国家/省份',
      supplier: '请选择供应商',
      keyword: '输入供应商关键字',
      position: '快速定位供应商',
      notFound: '没有找到供应商？',
      create: '创建供应商',
      distributor: '产品对应系统分销商',
      account: '分销商账号',
      password: '分销商密码',
      enterAccount: '输入分销商账号',
      enterPassword: '输入分销商密码',
      createAndEstablish: '创建分销商',
      establish: '建立串货关系',
      keywordTip: '请输入关键字',
      supTip: '请选择供应商',
      disTip: '分销商信息不能为空',
      audit: '开通串货成功，商户正在审核',
      pass: '开通串货成功'
    },
    recharge: {
      title: '充值记录',
      dealDate: '交易日期',
      '7days': '最近7天',
      '30days': '最近30天',
      recordNumber: '序号',
      date: '日期',
      operator: '操作人',
      originalBalance: '原有余额',
      rechargeAmount: '充值金额',
      accountBalance: '账户余额',
      transaction: '流水号',
      rechargeAccount: '到账账户',
      rechargeWay: '充值方式',
      explanation: '操作说明',
      endTip: '请输入结束时间',
      startTip: '请输入开始时间'
    },
    record: {
      title: '提现记录',
      dealDate: '交易日期',
      '7days': '最近7天',
      '30days': '最近30天',
      withdrawalNumber: '序号',
      date: '日期',
      operator: '操作人',
      originalBalance: '原有余额',
      withdrawalAmount: '提现金额',
      accountBalance: '账户余额',
      transaction: '流水号',
      withdrawalAccount: '提现账户',
      withdrawalWay: '提现方式',
      explanation: '操作说明'
    },
    productDetail: {
      productIntro: '产品简介',
      noLimit: '预订数量不限',
      autoConfirm: '需人工确认',
      sendMsg: '发送短信',
      supportThat: '当天可订',
      validity: '有效期',
      ahead: '提前',
      day: '天',
      max: '最多',
      num: '件'
    },
    qr: {
      paymentCode: '支付码',
      use: '请使用支付宝扫描以下二维码向',
      zwy: '广州自我游网络科技有限公司',
      nullString: '进行支付'
    }
  }
}
export { zh }


// WEBPACK FOOTER //
// ./src/i18n/zh.js